var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmojiFaceSadLtr = function SvgEmojiFaceSadLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 50C8 26.804 26.804 8 50 8s42 18.804 42 42-18.804 42-42 42S8 73.196 8 50m78.967 0c0-20.416-16.55-36.967-36.967-36.967S13.033 29.583 13.033 50 29.584 86.967 50 86.967 86.967 70.416 86.967 50",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.425 70.047a2.5 2.5 0 0 0 3.928-3.094c-4.522-5.742-11.191-10.175-20.408-10.175S34.058 61.21 29.536 66.953a2.5 2.5 0 0 0 3.928 3.094c3.778-4.798 9.097-8.27 16.48-8.27s12.703 3.472 16.48 8.27M39 39a4 4 0 1 1-8 0 4 4 0 0 1 8 0m30 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })));
};
export default SvgEmojiFaceSadLtr;